module.exports = __webpack_public_path__ + "web/img/chapter-50.6775887e.png";